import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="mt-16 border-t border-pink-100 bg-white/80 backdrop-blur">
            <div className="mx-auto max-w-5xl space-y-3 px-4 py-8 text-center text-sm text-slate-600">
                <p>&copy; {new Date().getFullYear()} UnicorNation&reg; All rights reserved.</p>

                <div className="flex flex-wrap justify-center gap-4">
                    <Link to="/privacy" className="transition hover:text-pink-500">
                        Privacy Policy
                    </Link>
                    <Link to="/terms" className="transition hover:text-pink-500">
                        Terms of Service
                    </Link>
                    <Link
                        to="/advertising-disclosure"
                        className="transition hover:text-pink-500"
                    >
                        Advertising Disclosure
                    </Link>
                </div>

                <p className="text-xs text-slate-500">
                    Some links and banners on this site may be sponsored or affiliate
                    links. UnicorNation is an event listing service only and does not run
                    or manage the events displayed.
                </p>
            </div>
        </footer>
    );
}
